import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
export class PaginatorService {
/**
 * @param {?} http
 */
constructor(private http: HttpClient) {}
/**
 * This is used to list all by paginator
 * @param {?} url
 * @return {?}
 */
listByPaginator(url): Observable<any> {
    return this.http.get(url);
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function PaginatorService_tsickle_Closure_declarations() {
/** @type {?} */
PaginatorService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PaginatorService.ctorParameters;
/** @type {?} */
PaginatorService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
